import React from 'react';
import Translator from "../shared/Translator";
import Container from "@material-ui/core/Container";


export default ({ component }) => {
  const text = <Translator translates={component.translate}/>
  return (<Container component="section" maxWidth={"lg"} className="titleMargin-0 titleContrast linkContrast" style={{ textAlign: component.alignement }} children={text ? text : ""}/>)
};
